import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

// Styles
import styles from './index.module.sass';

export default function Checkout({ device }) {
  const { screenSize = 'desktop' } = device || {};
  const { hostedTransactionIdentifier = '' } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      <iframe
        src={`https://protectpaytest.propay.com/hpp/v2/${hostedTransactionIdentifier}`}
        title='TMBcheckout'
        width='100%'
        name='TMBcheckout'
        scrolling='no'
        className={styles.propayiframe}></iframe>
    </div>
  );
}
